import { useCallback } from 'react'

import { createSearchParams, useNavigate } from 'react-router-dom'

import { isPresent } from '@utils/helpers'

export interface NavigateParamsFunction {
  (url: string, params: object): void
}

const useNavigateParams = (): NavigateParamsFunction => {
  const navigate = useNavigate()

  return useCallback((url, params) => {
    // Removes param if the value is empty empty
    const cleanedParams = Object.keys(params)
      .filter((key) => isPresent(params[key]))
      .reduce((cleaned, key) => ({ ...cleaned, [key]: params[key] }), {})

    navigate({
      pathname: url,
      search: createSearchParams(cleanedParams).toString(),
    })
  }, [])
}

export default useNavigateParams
